import { useTranslation } from "react-i18next";
import { memo } from "react";
import ClassicButton from "../../Resources/components/Buttons/ClassicButton";
import Title from "./Title";
import Description from "./Description";
import SvgShape from "./SvgShape";
import LeftImage from "./LeftImage";
import RightImage from "./RightImage";
import { sendWhatsappMessage } from "../../../utils";
import appConfig from "../../../utils/config/appConfig.json"

const HeroSection = memo(function HeroSection() {
	const { t } = useTranslation();
	const message = t("navBarItems.floatingActionShortcuts.whatsapp.defaultMessage");
  	const phone = appConfig.company.whatsappNumber;

	return (
		<section 
			className={`m-0 p-0 w-screen min-h-[300px] sm:h-[65vw] md:min-h-[499.2px] lg:h-[65vw] overflow-y-visible bg-transparent`}
		>
			<SvgShape />
			
			<div className="w-[90%] relative left-1/2 -translate-x-1/2 flex flex-cols justify-center">
				<div className="w-[45%] m-auto flex flex-col gap-3 sm:gap-4 lg:gap-6 2xl:gap-[2vw] pt-4">
					<Title
						title={t("heroSection.title")}
						subtitle={t("heroSection.subtitle")}
					/>
					<Description
						descriptionParagraph1={t(
							"heroSection.descriptionParagraph1"
						)}
						descritionParagraph2={t(
							"heroSection.descritionParagraph2"
						)}
					/>
					<ClassicButton
						buttonText={t("heroSection.callToActionButton")}
						showArrow={true}
						onClick={() => sendWhatsappMessage(phone, message)}
					/>

					<LeftImage />
				</div>

				<RightImage />
			</div>
		</section>
	);
});

export default HeroSection;